import { Component, Inject } from '@angular/core';
import { MAT_DIALOG_DATA, MatDialogRef } from '@angular/material/dialog';
import { Utils } from '../../utils.class';
import { Chat } from '../chat';
import { ChatMessage } from '../chat-message.interface';

@Component({
    selector: 'app-chat-message-info-dialog',
    templateUrl: './chat-message-info-dialog.component.html',
    styleUrls: ['./chat-message-info-dialog.component.scss'],
    standalone: false,
})
export class ChatMessageInfoDialogComponent {
    Utils = Utils;

    constructor(
        public dialogRef: MatDialogRef<ChatMessageInfoDialogComponent>,
        @Inject(MAT_DIALOG_DATA) public data: {
            chat: Chat;
            message: ChatMessage;
        }
    ) {}
}
